import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FeedbackForm = () => {
  const [fullName, setFullName] = useState('');
  const [message, setMessage] = useState('');

  const handleFullNameChange = (e) => {
    setFullName(e.target.value);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
    const response = await fetch('https://campus-closet-server.vercel.app/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fullName, message })
      });
       if (response.ok) {
        toast.success('Thank You for your feedback', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000
        });
         // Reset the input fields
    setFullName('');
    setMessage('');
    }
} catch (error) {
    toast.error('error occured sending your feedbac', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000
      });
}
  };

  return (
    <div className='bg-slate-50 py-5 px-4'>
    <div className="feedback-form max-w-2xl py-10 bg-blue-50 mx-auto p-4 rounded-lg shadow-md">
      <h2 className="text-2xl  mb-4 text-center font-bold">Leave Your Feedback</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="fullName" className="block text-gray-700">Full Name:</label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={fullName}
            onChange={handleFullNameChange}
            required
            className="w-full px-3 py-2 border rounded-lg  shadow-sm focus:outline-none focus:border-blue-500"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="message" className="block text-gray-700">Message:</label>
          <textarea
            id="message"
            name="message"
            rows="3"
            value={message}
            onChange={handleMessageChange}
            required
            className="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500"
          ></textarea>
        </div>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600">
          Submit Feedback
        </button>
      </form>
    </div>
    <ToastContainer />
    </div>
  );
};

export default FeedbackForm;
